import { use_slice_workspace } from '@/hooks/store/use_slices';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import React from 'react';
import { PLACEHOLDER_bar_line } from './PLACEHOLDER_bar_line';

interface Props {
  view: React.ReactElement;
  required_permission: string;
  entity: DTO__workspace_child_enity;
}

export const BarWorkspaceEntityOrBarLine = ({ view, required_permission, entity }: Props) => {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  let out = <></>;

  if (entity.is_shared || current_workspace_user.is_feature_pertmitted(required_permission)) {
    out = view;
  } else {
    out = <PLACEHOLDER_bar_line />;
  }

  return out;
};
